export enum enumHtsAssistantThreadItemKind {
  Message = 'message',
  Separator = 'separator',
  Result = 'result',
  Thinking = 'thinking',
  /** "An HTS code has been provided" + Start over, right under the active conversation's result. */
  Restart = 'restart',
  /** The classifier could not determine a code (status NoAnswer): note + Start over on the active conversation. */
  NoAnswer = 'noAnswer',
  /** A small informational line: where a carried conversation was held, an unfinished conversation (history, #13385). */
  Note = 'note',
}
